import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import LinkInterceptor from '../components/LinkInterceptor';
import '../styles/LandingPage.css';

// Set this to true to enable animation, false to disable
const ENABLE_ANIMATION = true;

const LandingPage: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile devices
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Check on initial load
    checkMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkMobile);
    
    // Clean up event listener
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  console.log('[DEBUG LandingPage] Rendering with SEO Helmet tags');

  return (
    <div className="landing-page">
      <Helmet>
        <title>SpitFire Braai Catering | Authentic South African Braai Events</title>
        <meta name="description" content="SpitFire Braai Catering delivers authentic South African braai experiences for events, functions, and celebrations. Professional catering services across South Africa." />
        <meta property="og:title" content="SpitFire Braai Catering | Authentic South African Braai Events" />
        <meta property="og:description" content="Authentic South African braai experiences for events, functions, and celebrations." />
        <meta property="og:url" content="https://www.spitfirebraai.co.za/" />
        <link rel="canonical" href="https://www.spitfirebraai.co.za/" />
      </Helmet>
      <LinkInterceptor to="/home" className="logo-link">
        <img
          src="/graphics/Main LOGO 1 transparent.png"
          alt="SpitFire Logo"
          className={ENABLE_ANIMATION ? "logo animated" : "logo"}
          style={{
            width: '90%',
            maxWidth: '1200px',
            maxHeight: '80vh',
            objectFit: 'contain',
            margin: '0 auto',
            cursor: 'pointer'
          }}
        />
        <div className="logo-caption">
          {isMobile ? "Tap anywhere to continue" : "Click anywhere to continue"}
        </div>
        <div className="logo-hint">
          {isMobile ? "(or try swiping the screen)" : "(or try moving your mouse)"}
        </div>
      </LinkInterceptor>
    </div>
  );
};

export default LandingPage;